import { DocumentMimeKind } from './types';

const IMAGE_TYPES = ['image/jpeg', 'image/jpg', 'image/png'];

export function classifyMimeType(mimeType?: string | null): DocumentMimeKind {
    const type = (mimeType || '').toLowerCase().split(';')[0].trim();

    if (!type || type === 'application/octet-stream') {
        return 'unsupported';
    }
    if (type === 'application/pdf') {
        return 'pdf';
    }
    if (IMAGE_TYPES.indexOf(type) >= 0) {
        return 'image';
    }
    return 'unsupported';
}

function sniffMimeKind(header: Uint8Array): DocumentMimeKind | null {
    if (header.length >= 4
        && header[0] === 0x25 && header[1] === 0x50 && header[2] === 0x44 && header[3] === 0x46) {
        return 'pdf';
    }
    if (header.length >= 2 && header[0] === 0xff && header[1] === 0xd8) {
        return 'image';
    }
    if (header.length >= 4
        && header[0] === 0x89 && header[1] === 0x50 && header[2] === 0x4e && header[3] === 0x47) {
        return 'image';
    }
    return null;
}

export async function classifyFromUrl(url: string): Promise<{ mimeKind: DocumentMimeKind; mimeType?: string }> {
    try {
        const response = await fetch(url, { method: 'GET' });
        const blob = await response.blob();
        const declaredType = blob.type;
        let mimeKind = classifyMimeType(declaredType);

        if (blob.size > 4) {
            const header = new Uint8Array(await blob.slice(0, 5).arrayBuffer());
            const sniffed = sniffMimeKind(header);

            if (sniffed) {
                mimeKind = sniffed;
            }
        }
        const mimeType = mimeKind === 'pdf'
            ? 'application/pdf'
            : (mimeKind === 'image'
                ? (declaredType && declaredType.indexOf('image/') === 0 ? declaredType : 'image/jpeg')
                : (declaredType || undefined));
        return { mimeKind, mimeType };
    } catch {
        return { mimeKind: 'unsupported' };
    }
}
